module.exports = __webpack_public_path__ + "img/schnittkante_beige_ral1014.d022aa8d.jpg";